<div class="container-fluid px-4 mt-4 mb-5">
    <div class="cp-page-header mb-3">
        <div class="cp-page-title"><i class="fa-solid fa-store me-2"></i>Gestión del recinto</div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de ingreso</a></li>
                <li class="breadcrumb-item"><a routerLink="/control-ingreso/dependencias">Dependencias</a></li>
                <li class="breadcrumb-item active">Recinto</li>
            </ol>
        </nav>
    </div>

    <ul class="nav nav-pills cp-tabs mb-4" *ngIf="dataId>0">
        <li class="nav-item"><a class="nav-link" [class.active]="active === 0" (click)="active = 0" href="javascript:void(0);"><i class="fa-solid fa-house-user me-1"></i>Home</a></li>
        <li class="nav-item"><a class="nav-link" [class.active]="active === 1" (click)="active = 1" href="javascript:void(0);"><i class="fa-solid fa-right-to-bracket me-1"></i>Ingresos</a></li>
        <li class="nav-item" *ngIf="hideRound==0"><a class="nav-link" [class.active]="active === 2" (click)="active = 2" href="javascript:void(0);"><i class="fa-solid fa-route me-1"></i>Rondas</a></li>
        <li class="nav-item"><a class="nav-link" [class.active]="active === 3" (click)="active = 3" href="javascript:void(0);"><i class="fa-solid fa-users me-1"></i>Empleados</a></li>
        <li class="nav-item"><a class="nav-link" [class.active]="active === 4" (click)="active = 4" href="javascript:void(0);"><i class="fa-solid fa-truck me-1"></i>Proveedores</a></li>
        <li class="nav-item"><a class="nav-link" [class.active]="active === 5" (click)="active = 5" href="javascript:void(0);"><i class="fa-solid fa-user-group me-1"></i>Visitantes</a></li>
    </ul>

    <div *ngIf="dataId>0">
                    <!-- Tab Content Unificado -->
                    <div class="tab-content h-100">
                        <!-- Tab 0 - Home -->
                        <div class="tab-pane fade h-100" [class.show]="active === 0" [class.active]="active === 0">
<div class="content-wrapper">
                                <!-- Store Information Card -->
                                <div class="card mb-4">

                                    <form novalidate [formGroup]="form" (ngSubmit)="update()">
                                        <div class="card-body p-3">
                                            <!-- Layout en dos columnas para optimizar espacio -->
                                            <div class="row g-3">
                                                <!-- Columna izquierda: Formulario compacto -->
                                                <div class="col-lg-8">
                                                    <!-- Información General -->
                                                    <div class="form-section mb-3">
                                                        <h6 class="fw-bold text-uppercase small text-muted mb-2">
                                                            <i class="fas fa-info-circle me-2"></i>
                                                            Información General
                                                        </h6>

                                                        <div class="row g-2">
                                                            <div class="col-md-6">
                                                                <label class="form-label fw-semibold small">Razón
                                                                    Social</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-building text-muted"></i>
                                                                    </span>
                                                                    <input type="text"
                                                                        class="form-control border-start-0 text-capitalize"
                                                                        formControlName="name"
                                                                        placeholder="Ingrese la razón social"
                                                                        maxlength="50">
                                                                </div>
                                                                <small class="text-muted">Máximo 50 caracteres</small>
                                                            </div>

                                                            <div class="col-md-6">
                                                                <label class="form-label fw-semibold small">RUT</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-id-card text-muted"></i>
                                                                    </span>
                                                                    <input (keyup)="onFormatRut($event)" type="text"
                                                                        class="form-control border-start-0"
                                                                        formControlName="rut"
                                                                        placeholder="12.345.678-9">
                                                                </div>
                                                            </div>

                                                            <div class="col-12">
                                                                <label
                                                                    class="form-label fw-semibold small">Instalación</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-map-location text-muted"></i>
                                                                    </span>
                                                                    <select class="form-select border-start-0"
                                                                        formControlName="facility_id">
                                                                        <option value="0">Seleccione una instalación
                                                                        </option>
                                                                        <option *ngFor="let item of facilitys"
                                                                            [value]="item?.id">
                                                                            {{item?.name}}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Responsable y Contacto en una sola sección -->
                                                    <div class="form-section mb-3">
                                                        <h6 class="fw-bold text-uppercase small text-muted mb-2">
                                                            <i class="fas fa-user-tie me-2"></i>
                                                            Responsable y Contacto
                                                        </h6>

                                                        <div class="row g-2">
                                                            <div class="col-md-6">
                                                                <label
                                                                    class="form-label fw-semibold small">Propietario/Gerente</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-user text-muted"></i>
                                                                    </span>
                                                                    <input type="text"
                                                                        class="form-control border-start-0 text-capitalize"
                                                                        formControlName="owner"
                                                                        placeholder="Nombre del responsable"
                                                                        maxlength="50">
                                                                </div>
                                                            </div>

                                                            <div class="col-md-6">
                                                                <label class="form-label fw-semibold small">Teléfono
                                                                    Responsable</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-phone text-muted"></i>
                                                                    </span>
                                                                    <input type="text"
                                                                        class="form-control border-start-0"
                                                                        formControlName="owner_phone"
                                                                        placeholder="+56 9 1234 5678">
                                                                </div>
                                                            </div>

                                                            <div class="col-md-6">
                                                                <label
                                                                    class="form-label fw-semibold small">Email</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-envelope text-muted"></i>
                                                                    </span>
                                                                    <input type="email"
                                                                        class="form-control border-start-0"
                                                                        formControlName="email"
                                                                        placeholder="contacto@empresa.com">
                                                                </div>
                                                            </div>

                                                            <div class="col-md-6">
                                                                <label
                                                                    class="form-label fw-semibold small">Teléfono</label>
                                                                <div class="input-group input-group-sm">
                                                                    <span
                                                                        class="input-group-text bg-light border-end-0">
                                                                        <i class="fas fa-phone text-muted"></i>
                                                                    </span>
                                                                    <input type="tel"
                                                                        class="form-control border-start-0"
                                                                        formControlName="phone"
                                                                        placeholder="+56 2 1234 5678">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Columna derecha: Contenido HTML dinámico -->
                                                <div class="col-lg-4">
                                                    <div class="additional-content-section">
                                                        <h6 class="fw-bold text-uppercase small text-muted mb-2">
                                                            <i class="fas fa-file-code me-2"></i>
                                                            Información Adicional
                                                        </h6>

                                                        <div class="html-content-container">
                                                            <!-- Loading state -->
                                                            <div *ngIf="loadingAdditionalContent"
                                                                class="text-center py-3">
                                                                <div
                                                                    class="spinner-border spinner-border-sm text-primary me-2">
                                                                </div>
                                                                <small class="text-muted">Cargando contenido...</small>
                                                            </div>

                                                            <!-- Contenido HTML del editor -->
                                                            <div *ngIf="!loadingAdditionalContent && additionalHtmlContent"
                                                                class="dynamic-html-content"
                                                                [innerHTML]="additionalHtmlContent">
                                                            </div>

                                                            <!-- Estado vacío -->
                                                            <div *ngIf="!loadingAdditionalContent && !additionalHtmlContent"
                                                                class="text-center py-3 text-muted">
                                                                <i class="fas fa-file-alt fa-2x mb-2 opacity-50"></i>
                                                                <p class="mb-0 small">No hay contenido adicional</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Footer con botón de guardar -->
                                        <div class="card-footer py-2 px-3" *ngIf="level==99">
                                            <div class="row align-items-center">
                                                <div class="col-auto">
                                                    <button class="btn btn-primary" type="submit">
                                                        <i class="fas fa-save me-2"></i>
                                                        Guardar Cambios
                                                    </button>
                                                </div>
                                                <div class="col">
                                                    <small class="text-muted">
                                                        <i class="fas fa-info-circle me-1"></i>
                                                        Los cambios se guardarán automáticamente
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>

                        <!-- Tab 1 - Ingresos -->
                        <div class="tab-pane fade h-100" [class.show]="active === 1" [class.active]="active === 1">
<div class="content-wrapper">
                                <app-admin-records />
                            </div>
                        </div>

                        <!-- Tab 2 - Rondas -->
                        <div class="tab-pane fade h-100" [class.show]="active === 2" [class.active]="active === 2"
                            *ngIf="hideRound==0">
<div class="content-wrapper">
                                <app-admin-rounds [facilityId]="facility_id" />
                            </div>
                        </div>

                        <!-- Tab 3 - Empleados -->
                        <div class="tab-pane fade h-100" [class.show]="active === 3" [class.active]="active === 3">
<div class="content-wrapper">
                                <app-list-employees [storesId]="dataId" />
                            </div>
                        </div>

                        <!-- Tab 4 - Proveedores -->
                        <div class="tab-pane fade h-100" [class.show]="active === 4" [class.active]="active === 4">
<div class="content-wrapper">
                                <app-list-providers [storesId]="dataId" />
                            </div>
                        </div>

                        <!-- Tab 5 - Visitantes -->
                        <div class="tab-pane fade h-100" [class.show]="active === 5" [class.active]="active === 5">
<div class="content-wrapper">
                                <app-list-visitor [storesId]="dataId" />
                            </div>
                        </div>
                    </div>
    </div>

    <div class="card" *ngIf="dataId<=0">
        <div class="cp-empty">
            <i class="fa-solid fa-triangle-exclamation"></i>Complete la información del recinto para acceder a las opciones de gestión.
        </div>
    </div>
</div>

<!-- Modal for Add Facility -->
<ng-template #addFacility let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">
            <i class="fas fa-plus-circle text-primary me-2"></i>
            Nueva Instalación
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
        <app-add-facility (success)="getFacility(); form.get('facility_id')?.setValue($event)" />
    </div>
    <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">
            <i class="fas fa-times me-2"></i>
            Cancelar
        </button>
    </div>
</ng-template>